/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SettingsProfileSubNav_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type profileSecurity_viewer$ref: FragmentReference;
declare export opaque type profileSecurity_viewer$fragmentType: profileSecurity_viewer$ref;
export type profileSecurity_viewer = {|
  +id: string,
  +$fragmentRefs: SettingsProfileSubNav_viewer$ref,
  +$refType: profileSecurity_viewer$ref,
|};
export type profileSecurity_viewer$data = profileSecurity_viewer;
export type profileSecurity_viewer$key = {
  +$data?: profileSecurity_viewer$data,
  +$fragmentRefs: profileSecurity_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "profileSecurity_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SettingsProfileSubNav_viewer"
    }
  ],
  "type": "Viewer"
};
// prettier-ignore
(node/*: any*/).hash = '1363c06b358bafb6a704bb6771734df4';

module.exports = node;
